import '../../scss/look-search.scss';

import {HttpMethods} from 'tagwalk-api-client/assets/js/common/enums';
import {initFilters} from "../collection/filters";
import {fetchApi} from '../common/helpers';
import {createPaywall} from '../common/paywall';
import {initRelatedTags} from '../common/similarTags';
import {initMoodboardQuicksaveIfConnected} from '../moodboard_quicksave/index';
require('../common/viewer');
require('../common/stickySearch');
require('../common/photoSizeControl');
initFilters();
initRelatedTags();

document.addEventListener('DOMContentLoaded', () => {
    saveTagsSearch();
    initMoodboardQuicksaveIfConnected();

    createPaywall({
        authorizedPlans: ['all-included', 'student-special', 'power-searcher'],
        context: 'search',
        onLock: () => {
            const medias = document.querySelectorAll('.photo-list-item');
            Array.from(medias).forEach((element, index) => {
                element.classList.add('non-clickable');
                element.addEventListener('click', (event) => {
                    // Disable the viewer to avoid having two paywalls showing at the same time (the moodboard one)
                    event.preventDefault();
                    event.stopPropagation();
                });

                if (index >= 0) {
                    element.remove();
                }
            });

            document.querySelector('#nav-pagination')?.remove();
        },
        overrideSegment: (subscription, parent) => {
            if (
                subscription.search_count > 2
                && (!subscription.plan || subscription.plan === 'trend-master')
                && ['canceled', 'past_due'].includes(subscription.status) === false
            ) {
                return (subscription.plan ?? 'free-user') + '-who-made-two-tag-searches'
            }

            return parent(subscription);
        },
        shouldAbort: (subscription) => {
            const tagsInQuery = getTagsInQuery();
            const media = document.querySelector('.photo-list-item');

            if (!media) {
                return {result: true, reason: 'empty search results'};
            }

            if (tagsInQuery.length === 0) {
                return {result: true, reason: 'no keywords in the query search params'};
            }

            if (subscription.search_count < 3) {
                return {result: true, reason: 'less than 3 searches by keywords'};
            }

            return {result: false};
        }
    });
});

const saveTagsSearch = () => {
    const tagsInQuery = getTagsInQuery();
    const media = document.querySelector('.photo-list-item');

    if (tagsInQuery.length === 0 || !media) {
        return;
    }

    const previousSearch = localStorage.getItem('tags_previous_search');
    const query = tagsInQuery.join(',');

    if (previousSearch === query) {
        return;
    }

    fetchApi('api_user_update_tags_search_count', HttpMethods.post);
    localStorage.setItem('tags_previous_search', query);
}

const getTagsInQuery = () => {
    const searchParams = new URLSearchParams(window.location.search);

    const tags = [];

    for (const [key, value] of searchParams.entries()) {
        if (key.startsWith('tags[')) {
            tags.push(value);
        }
    }

    return searchParams.has('tags') ? [searchParams.get('tags')] : tags;
}
